/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StackCreatorPlayersQueryVariables = {|
  greenMachineSessionID: string
|};
export type StackCreatorPlayersQueryResponse = {|
  +playersForGreenMachineSession: ?$ReadOnlyArray<?{|
    +id: string,
    +slatePlayer: {|
      +id: string,
      +player: {|
        +id: string,
        +name: string,
        +shortenedName: ?string,
        +team: ?{|
          +abbreviation: string,
          +name: ?string,
        |},
      |},
      +position: ?string,
      +fppg: any,
      +salary: number,
      +rosterSlots: {|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +name: string
          |}
        |}>
      |},
      +slateCompetition: ?{|
        +prettyStartTime: ?string
      |},
      +gupPercProj: ?any,
      +projPoints: ?any,
    |},
  |}>,
  +whoAmI: ?{|
    +groups: $ReadOnlyArray<{|
      +name: string
    |}>
  |},
|};
export type StackCreatorPlayersQuery = {|
  variables: StackCreatorPlayersQueryVariables,
  response: StackCreatorPlayersQueryResponse,
|};
*/


/*
query StackCreatorPlayersQuery(
  $greenMachineSessionID: ID!
) {
  playersForGreenMachineSession(greenMachineSessionId: $greenMachineSessionID, sortBy: "team") {
    id
    slatePlayer {
      id
      player {
        id
        name
        shortenedName
        team {
          abbreviation
          name
          id
        }
      }
      position
      fppg
      salary
      rosterSlots {
        edges {
          node {
            name
            id
          }
        }
      }
      slateCompetition {
        prettyStartTime
        id
      }
      gupPercProj
      projPoints
    }
  }
  whoAmI {
    groups {
      name
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "greenMachineSessionID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "greenMachineSessionId",
    "variableName": "greenMachineSessionID"
  },
  {
    "kind": "Literal",
    "name": "sortBy",
    "value": "team"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortenedName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviation",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fppg",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salary",
  "storageKey": null
},
v9 = [
  (v3/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyStartTime",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gupPercProj",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projPoints",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "GroupType",
  "kind": "LinkedField",
  "name": "groups",
  "plural": true,
  "selections": (v9/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StackCreatorPlayersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GreenMachineSessionPlayerType",
        "kind": "LinkedField",
        "name": "playersForGreenMachineSession",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SlatePlayerType",
            "kind": "LinkedField",
            "name": "slatePlayer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PlayerType",
                "kind": "LinkedField",
                "name": "player",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamType",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterSlotTypeConnection",
                "kind": "LinkedField",
                "name": "rosterSlots",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RosterSlotTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RosterSlotType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SlateCompetitionType",
                "kind": "LinkedField",
                "name": "slateCompetition",
                "plural": false,
                "selections": [
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StackCreatorPlayersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GreenMachineSessionPlayerType",
        "kind": "LinkedField",
        "name": "playersForGreenMachineSession",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SlatePlayerType",
            "kind": "LinkedField",
            "name": "slatePlayer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PlayerType",
                "kind": "LinkedField",
                "name": "player",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamType",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterSlotTypeConnection",
                "kind": "LinkedField",
                "name": "rosterSlots",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RosterSlotTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RosterSlotType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SlateCompetitionType",
                "kind": "LinkedField",
                "name": "slateCompetition",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9892a70f344a43285ef5f083f40eaa9d",
    "id": null,
    "metadata": {},
    "name": "StackCreatorPlayersQuery",
    "operationKind": "query",
    "text": "query StackCreatorPlayersQuery(\n  $greenMachineSessionID: ID!\n) {\n  playersForGreenMachineSession(greenMachineSessionId: $greenMachineSessionID, sortBy: \"team\") {\n    id\n    slatePlayer {\n      id\n      player {\n        id\n        name\n        shortenedName\n        team {\n          abbreviation\n          name\n          id\n        }\n      }\n      position\n      fppg\n      salary\n      rosterSlots {\n        edges {\n          node {\n            name\n            id\n          }\n        }\n      }\n      slateCompetition {\n        prettyStartTime\n        id\n      }\n      gupPercProj\n      projPoints\n    }\n  }\n  whoAmI {\n    groups {\n      name\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '83eff31b32dd71e81d82579a6fa9c23d';

module.exports = node;
